import Navbar from 'react-bootstrap/Navbar';
import Nav from 'react-bootstrap/Nav';
import Container from 'react-bootstrap/Container';
import { Button } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import styled from 'styled-components';
import React from 'react';
import * as styles from './topMenu.module.css';
import LinkComponent from '../../utils/linkComponent';

const StyledLink = styled((props) => <LinkComponent {...props} />)`
	font-size: 16px;
	margin-left: 1em;
	color: var(--secondary_2);
	padding: 0.3em;

	text-decoration: none;
	:hover {
		color: var(--link_color);
	}
`;

const NavStyled = styled.div`
	.navbar .navbar-nav {
		color: var(--secondary_2);
		font-size: 16px;
	}

	.navbar-nav .dropdown-menu {
		z-index: 1031;
	}

	/* .loginButton {
		background-color: var(--secondary_9);
		color: var(--secondary_6);
		width: 7em;
		text-align: center;
		font-size: 16px;
		margin-left: 1em;
		padding: 0.3em;
		cursor: pointer;
	} */

	.topMenu {
		padding: 0;
	}

	.navbar-light .navbar-brand {
		color: var(--secondary_6);
	}

	.navbar-light .navbar-toggler {
		border-color: var(--secondary_7) !important;
		color: var(--secondary_2) !important;
	}
	.nav-link {
		margin-left: 1em;
		background-color: var(--primary);
		color: var(--secondary_8) !important;
		width: 7em;
		text-align: center;
	}

	.top-menu {
		line-height: 24px;
	}
`;

const TopMenu = (props) => {
	const { menu, bgColor, buttonShape } = props;

	// Determine button class based on shape
	const buttonClass =
		buttonShape === 'rectangle' ? 'btn-rectangle' : 'btn-round';

	return (
		<NavStyled>
			<Navbar
				expand='xl'
				variant='light'
				className={styles.topMenu}
				style={{ background: bgColor }}
			>
				<Container>
					<Navbar.Brand style={{ cursor: 'pointer' }}></Navbar.Brand>
					<Navbar.Toggle aria-controls='basic-navbar-nav' />
					<Navbar.Collapse id='basic-navbar-nav' className='top-menu'>
						<Nav className='ms-auto'>
							{menu.map((item) => {
								return (
									<StyledLink to={`${item.path}`} key={item.title}>
										{item.title}
									</StyledLink>
								);
							})}
							<Button
								variant='primary'
								className={buttonClass}
								as={LinkComponent}
								to='/login'
								style={{ marginLeft: '1em' }}
							>
								LOGIN
							</Button>
							<Button
								variant='primary'
								className={buttonClass}
								as={LinkComponent}
								to='/join'
								style={{ marginLeft: '1em' }}
							>
								JOIN NOW
							</Button>
						</Nav>
					</Navbar.Collapse>
				</Container>
			</Navbar>
		</NavStyled>
	);
};

export default TopMenu;
